import { render, staticRenderFns } from "./IconFeed.vue?vue&type=template&id=147aa409&"
import script from "./IconFeed.vue?vue&type=script&lang=js&"
export * from "./IconFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports